import { formatDuration } from "@bandwith/time";
import { MediaItemContent } from "@bandwith/ui";
import { useQuery } from "@tanstack/react-query";
import { Plus } from "lucide-react";
import { AuthLinkButton } from "../components/AuthLinkButton";
import { RouterLinkWrapper } from "../components/RouterLinkWrapper";
import type { SongListItem } from "../lib/api";
import { songsQuery } from "../lib/queries";

export function Home() {
  const { data, isLoading, error } = useQuery(songsQuery());
  // Covers live in setlists, not on the Songs page
  const songs = data?.filter((song: SongListItem) => !song.isCover);

  if (isLoading) {
    return <div className="text-text-muted">Loading songs...</div>;
  }

  if (error) {
    return <div className="text-red-muted">Error: {error.message}</div>;
  }

  return (
    <section>
      <div className="mb-4 flex justify-end gap-2">
        <AuthLinkButton to="/songs/new">
          <Plus aria-hidden="true" className="h-3.5 w-3.5" />
          Add Song
        </AuthLinkButton>
      </div>
      <ul className="space-y-2" data-testid="song-list">
        {songs?.map((song: SongListItem, index: number) => {
          const subtitle =
            [
              song.author?.name,
              song.primaryDurationSeconds
                ? formatDuration(song.primaryDurationSeconds)
                : null,
            ]
              .filter(Boolean)
              .join(" · ") || undefined;

          return (
            <li
              key={song.id}
              data-testid="song-item"
              className="flex animate-list-item rounded-md border border-border-subtle bg-bg-secondary p-4 transition-colors hover:bg-bg-tertiary"
              style={{ animationDelay: `${index * 30}ms` }}
            >
              <MediaItemContent
                title={song.title}
                subtitle={subtitle}
                linkHref={`/songs/${song.id}`}
                LinkWrapper={RouterLinkWrapper}
              />
            </li>
          );
        })}
      </ul>
    </section>
  );
}
